import { CluCustomInputItem } from "../cashdesk/cashdesk.models";

export interface CashDeskOptions {
    mode: 'fullscreen' | 'navigation';
    quickAccess : { 
        showButton_LISTECLIENTS : boolean, 
        showButton_CLOTUREX : boolean, 
        showButton_ANNULERTICKET : boolean, 
        showButton_ENATTENTE : boolean,
        showButton_RAPPELTICKET : boolean,
        showButton_IMPRIMER : boolean,
        showButton_MVTS_CAISSE : boolean
        showButton_OPENCASHDESK : boolean
    }, 
    envSettings : {
        android_PREVENTKEYBOARD_MAIN : boolean, 
        enable_CUSTOMTOOLBAR : boolean,
        fields_CUSTOMTOOLBAR : string[],
        inputs_CUSTOMTOOLBAR : CluCustomInputItem[], 
        enable_CUSTOMSIDEBAR : boolean,
        width_CUSTOMSIDEBAR : number, 
        useTTC_CUSTOMSIDEBAR : boolean, 
        showPCOUNT_CUSTOMSIDEBAR : boolean,

        defineTICKET_ROW_MENU_DISPLAY_MODE_CUSTOMSIDEBAR : 'standard' | 'extended',
        isTICKET_ROW_MENU_VISIBLE_ON_ALL_ROWS_CUSTOMSIDEBAR : boolean,
        useTICKET_ROW_MENU_ENABLE_DELETE_CUSTOMSIDEBAR : boolean,
        useTICKET_ROW_MENU_ENABLE_AUDIT_CUSTOMSIDEBAR : boolean,
        useTICKET_ROW_MENU_ENABLE_INFO_CUSTOMSIDEBAR : boolean,
        useTICKET_ROW_MENU_ENABLE_DISCOUNT_CUSTOMSIDEBAR : boolean,

        enable_CUSTOMFUNCTIONS : boolean,
        hiddenFn_CUSTOMFUNCTIONS : string[],
        orderByFn_CUSTOMFUNCTIONS : string[], 

        forcePicker_COLLABORATEUR : boolean, 
        forceDisplay_COLLABORATEUR : boolean, 

        forceDisplay_CONDITIONNEMENT : boolean, 
        enable_PAYMENTNUMPAD : boolean,
        enable_PAYMENTEXPRESS_VALIDATE : boolean,
        enable_PAYMENTNUMPAD_AUTOOPENING : boolean,

        enable_MODERGSORTING : boolean, 
        orderBy_MODERGSORTING : string[],

        blockAutoFocus_MAIN : boolean, 
        
        densityMode_PVIEW : 'auto' | 'compact' | 'large', 
        densityMode_PVIEW_COMPACT_TOOLBARDISPLAYMODE : 'tabs' | 'ddl'
    }
}

export const defaults: CashDeskOptions = {
    mode: 'navigation', 
    quickAccess : { 
        showButton_LISTECLIENTS : false, 
        showButton_CLOTUREX : false, 
        showButton_ANNULERTICKET : false, 
        showButton_ENATTENTE : true, 
        showButton_RAPPELTICKET : true, 
        showButton_IMPRIMER : true, 
        showButton_MVTS_CAISSE : false,
        showButton_OPENCASHDESK : false
    }, 
    envSettings : {
        android_PREVENTKEYBOARD_MAIN : false, 
        enable_CUSTOMTOOLBAR : false,
        fields_CUSTOMTOOLBAR : [], 
        inputs_CUSTOMTOOLBAR : [], 
        enable_CUSTOMSIDEBAR : false,
        width_CUSTOMSIDEBAR : 400, 
        useTTC_CUSTOMSIDEBAR : false, 
        showPCOUNT_CUSTOMSIDEBAR : false,

        defineTICKET_ROW_MENU_DISPLAY_MODE_CUSTOMSIDEBAR : 'standard',
        isTICKET_ROW_MENU_VISIBLE_ON_ALL_ROWS_CUSTOMSIDEBAR : false,
        useTICKET_ROW_MENU_ENABLE_DELETE_CUSTOMSIDEBAR : false,
        useTICKET_ROW_MENU_ENABLE_AUDIT_CUSTOMSIDEBAR : false,
        useTICKET_ROW_MENU_ENABLE_INFO_CUSTOMSIDEBAR : false,
        useTICKET_ROW_MENU_ENABLE_DISCOUNT_CUSTOMSIDEBAR : false,
        
        enable_CUSTOMFUNCTIONS : false,
        hiddenFn_CUSTOMFUNCTIONS : [],
        orderByFn_CUSTOMFUNCTIONS : [], 

        forcePicker_COLLABORATEUR : false,
        forceDisplay_COLLABORATEUR : false,

        forceDisplay_CONDITIONNEMENT : false,
        enable_PAYMENTNUMPAD : false,
        enable_PAYMENTEXPRESS_VALIDATE : false,
        enable_PAYMENTNUMPAD_AUTOOPENING : false,
        
        enable_MODERGSORTING : false,
        orderBy_MODERGSORTING : [], 

        blockAutoFocus_MAIN : false,

        densityMode_PVIEW : 'auto',
        densityMode_PVIEW_COMPACT_TOOLBARDISPLAYMODE : 'ddl'
    }
};
  